module.exports = __webpack_public_path__ + "media/school.9c32ca50.mp3";